module.exports = __webpack_public_path__ + "img/img22.ef9fdd9c.svg";